import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { EmployeeRestService, RequestAccountDto, UserRestService } from '../../api/exa';
import { AuthService } from '../../services/auth.service';
import { DialogService } from '../../services/dialog.service';
import { EmployerService } from '../../services/employer.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { Utils } from '../../services/utils';
import { ValidationErrorMessage } from '../validation-error/validation-error-message';

@Component({
  selector: 'app-request-test-account-dialog',
  templateUrl: './request-test-account-dialog.component.html',
  styleUrls: ['./request-test-account-dialog.component.scss'],
})
export class RequestTestAccountDialogComponent implements OnInit {
  formGroup: UntypedFormGroup;
  validationMessages: { [key: string]: ValidationErrorMessage[] };

  constructor(
    private log: NGXLogger,
    private modalController: ModalController,
    private userRest: UserRestService,
    private errHandler: ErrorHandlerService,
    private dialog: DialogService,
    private translate: TranslateService,
    private auth: AuthService
  ) {}

  ngOnInit() {
    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl('', Validators.required),
      nachname: new UntypedFormControl('', Validators.required),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      telefon: new UntypedFormControl('', Validators.required),
      enterpriseName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
    });
    this.validationMessages = {
      name: [
        { type: 'required', message: 'Name erforderlich.' },
        // { type: 'minlength', message: 'Username must be at least 5 characters long.' },
      ],
      nachname: [
        { type: 'required', message: 'Nachname erforderlich.' },
        // { type: 'minlength', message: 'Username must be at least 5 characters long.' },
      ],
      email: [
        { type: 'required', message: 'E-Mail erforderlich.' },
        { type: 'email', message: 'E-Mail nicht gültig.' },
        // { type: 'minlength', message: 'Username must be at least 5 characters long.' },
      ],
      telefon: [
        { type: 'required', message: 'Telefon erforderlich.' },
        // { type: 'minlength', message: 'Username must be at least 5 characters long.' },
      ],
      enterpriseName: [
        { type: 'required', message: 'Betriebname erforderlich.' },
        { type: 'minlength', message: 'Name muss mindestens 3 Buchstaben lang sein' },
      ],
    };
  }

  async onClickOk() {
    Utils.validateAllFormFields(this.formGroup);
    if (this.formGroup.valid) {
      await this.dialog.showLoading('Bitte Warten');
      const request: RequestAccountDto = {
        contactName: this.formGroup.value.name,
        contactLastname: this.formGroup.value.nachname,
        contactEmail: this.formGroup.value.email,
        contactPhone: this.formGroup.value.telefon,
        enterpriseName: this.formGroup.value.enterpriseName,
      };
      this.userRest.requestTestAccountUsingPOST(request).subscribe(
        async (ret) => {
          await this.dialog.hideLoading();
          this.dialog.presentToast('Test-Konto angefagt, du bekommst in kurze eine Email');
          this.modalController.dismiss({
            requested: false,
          });
        },
        async (err) => {
          await this.dialog.hideLoading();
          this.errHandler.handleHttpError(err);
        }
      );
    }
  }

  onClickCancel() {
    this.modalController.dismiss({
      requested: true,
    });
  }
}
